// extracted by mini-css-extract-plugin
export default {"anchorText":"anchorText--5wJVP"};